import {wmsLayer} from '../../endpoints';
import rasterStyleFactory from './rasterStylesFactory';

const STYLES = {
    PNG: rasterStyleFactory('wms-png', 'tomtomWMSBasicPNG', wmsLayer, {'{format}': 'image/png'}),
    JPG: rasterStyleFactory('wms-jpg', 'tomtomWMSBasicJPG', wmsLayer, {'{format}': 'image/jpeg'})
};

export default function(format) {
    switch (format.toLowerCase()) {
    case 'image/png':
        return STYLES.PNG;
    case 'image/jpeg':
    case 'image/jpg':
        return STYLES.JPG;
    default:
        throw new Error(`Unknown WMS format: ${format}`);
    }
}



// WEBPACK FOOTER //
// ./map/tier/styleParts/wmsMap.js